import { render, staticRenderFns } from "./rateindex.vue?vue&type=template&id=52e9486a&scoped=true&"
import script from "./rateindex.vue?vue&type=script&lang=js&"
export * from "./rateindex.vue?vue&type=script&lang=js&"
import style0 from "./rateindex.vue?vue&type=style&index=0&id=52e9486a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9486a",
  null
  
)

export default component.exports